import React from "react";

/**
 * The mockup's `.lbl` — a tracked-out uppercase caption with a hairline running
 * off to the right. Structural only; carries no data and makes no claim.
 */
const AutomationSectionLabel = ({ children, ...props }) => (
  <h3 className="sa-lbl" {...props}>
    {children}
  </h3>
);

export default AutomationSectionLabel;
